module.exports = __webpack_public_path__ + "static/media/interaction-scroll.ea5c4278.gif";